import { HttpClient } from "@angular/common/http";
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
import { ToastService } from 'src/app/shared/services/toast.service';
import { IDeviceType } from "../models/device.interface";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';

@Injectable({
  providedIn: 'root'
})
export class DeviceTypeService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}DeviceType`

  constructor(private readonly http: HttpClient, protected readonly toast: ToastService) {
    super(toast);
  }

  listDevicesTypes(): Observable<ResponseDefault<IDeviceType[]>> {
    return this.http.get<ResponseDefault<IDeviceType[]>>(this.apiUrl);
  }
}
